import { useState, useEffect } from 'react';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('ccf_cookie_accepted');
    if (!accepted) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('ccf_cookie_accepted', 'true');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('ccf_cookie_accepted', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 animate-slide-up">
      <div className="w-full bg-background-50 border-t border-background-200/70 shadow-[0_-2px_16px_0_oklch(var(--foreground-950)/0.06)]">

        {/* ── Mobile layout (< sm) ── */}
        <div className="sm:hidden px-4 py-4">
          <div className="flex items-start gap-3 mb-3">
            <div className="w-9 h-9 flex items-center justify-center shrink-0 rounded-full bg-accent-100">
              <i className="ri-shield-check-line text-accent-600 text-base"></i>
            </div>
            <div>
              <p className="text-sm font-semibold text-foreground-900 leading-snug mb-1">Cookie Policy</p>
              <p className="text-xs text-foreground-600 leading-relaxed">
                We use cookies to enhance your experience, analyze traffic, and deliver personalized content. By continuing, you agree to our use of cookies.
              </p>
            </div>
          </div>
          <div className="flex gap-2">
            <button
              onClick={handleDecline}
              className="flex-1 py-2.5 rounded-lg border border-background-300 text-foreground-700 text-sm font-medium hover:bg-background-100 transition-colors cursor-pointer"
            >
              Decline
            </button>
            <button
              onClick={handleAccept}
              className="flex-1 py-2.5 rounded-lg bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 active:bg-accent-700 transition-colors cursor-pointer"
            >
              Accept
            </button>
          </div>
        </div>

        {/* ── Desktop layout (≥ sm) ── */}
        <div className="hidden sm:block">
          <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-14 py-3.5 flex items-center justify-between gap-6">
            <div className="flex items-center gap-3 flex-1 min-w-0">
              <div className="w-8 h-8 flex items-center justify-center shrink-0 rounded-full bg-accent-100">
                <i className="ri-shield-check-line text-accent-600 text-sm"></i>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">
                We use cookies to improve your browsing experience, analyze website traffic, and deliver personalized content. By continuing to use this site, you agree to our use of cookies.
              </p>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              <button
                onClick={handleDecline}
                className="px-4 py-2 rounded-lg border border-background-300 text-foreground-700 text-sm font-medium hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                Decline
              </button>
              <button
                onClick={handleAccept}
                className="inline-flex items-center gap-1.5 px-5 py-2 rounded-lg bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-check-line"></i>
                Accept Cookies
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}